'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_ExportAllRecipesPage$State() {
}
export { $c_Lmealorama_pages_ExportAllRecipesPage$State as $c_Lmealorama_pages_ExportAllRecipesPage$State };
$p = $c_Lmealorama_pages_ExportAllRecipesPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_ExportAllRecipesPage$State;
/** @constructor */
function $h_Lmealorama_pages_ExportAllRecipesPage$State() {
}
export { $h_Lmealorama_pages_ExportAllRecipesPage$State as $h_Lmealorama_pages_ExportAllRecipesPage$State };
$h_Lmealorama_pages_ExportAllRecipesPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 80204913;
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_pages_ExportAllRecipesPage$State) || false));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_pages_ExportAllRecipesPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kq)));
}
export { $isArrayOf_Lmealorama_pages_ExportAllRecipesPage$State as $isArrayOf_Lmealorama_pages_ExportAllRecipesPage$State };
var $d_Lmealorama_pages_ExportAllRecipesPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_ExportAllRecipesPage$State, "mealorama.pages.ExportAllRecipesPage$State", ({
  kq: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_ExportAllRecipesPage$State as $d_Lmealorama_pages_ExportAllRecipesPage$State };
//# sourceMappingURL=mealorama.pages.-Export-All-Recipes-Page$-State.js.map
